import React from 'react';

interface TriageStepProps {
  state: {
    isStaged: boolean | null;
    hasPrevious: boolean | null;
    parentCaseId: string;
    existingCases: string[];
  };
  actions: {
    setIsStaged: (val: boolean) => void;
    setHasPrevious: (val: boolean | null) => void;
    setParentCaseId: (val: string) => void;
  };
}

export const TriageStep: React.FC<TriageStepProps> = ({ state, actions }) => {
  return (
    <div className="flex flex-col space-y-8 animate-fadeIn">
      {/* Question 1: Staged? */}
      <div className="form-field-container">
        <label>Was the case staged? <span className="text-red-500">*</span></label>
        <div className="ml-2 mt-2 flex gap-x-6">
          <div className="flex items-center">
            <input 
              id="staged-yes" type="radio" className="custom-radio-input"
              checked={state.isStaged === true} 
              onChange={() => actions.setIsStaged(true)} 
            />
            <label htmlFor="staged-yes" className="custom-radio-label">Yes</label>
          </div>
          <div className="flex items-center">
            <input 
              id="staged-no" type="radio" className="custom-radio-input"
              checked={state.isStaged === false} 
              onChange={() => { actions.setIsStaged(false); actions.setHasPrevious(null); }} 
            />
            <label htmlFor="staged-no" className="custom-radio-label">No</label>
          </div>
        </div>
      </div>

      {/* Question 2: Previous Stage? */}
      {state.isStaged === true && (
        <div className="form-field-container animate-slideDown">
          <label>Has a previous stage already been uploaded for this case? <span className="text-red-500">*</span></label>
          <div className="ml-2 mt-2 flex gap-x-6">
            <div className="flex items-center">
              <input 
                id="prev-yes" type="radio" className="custom-radio-input"
                checked={state.hasPrevious === true} 
                onChange={() => actions.setHasPrevious(true)} 
              />
              <label htmlFor="prev-yes" className="custom-radio-label">Yes</label>
            </div>
            <div className="flex items-center">
              <input 
                id="prev-no" type="radio" className="custom-radio-input"
                checked={state.hasPrevious === false} 
                onChange={() => actions.setHasPrevious(false)} 
              />
              <label htmlFor="prev-no" className="custom-radio-label">No</label>
            </div>
          </div>
        </div>
      )}

      {/* Question 3: Dropdown */}
      {state.isStaged === true && state.hasPrevious === true && (
        <div className="form-field-container animate-slideDown">
          <label htmlFor="parentCaseId">Please specify the case ID: <span className="text-red-500">*</span></label>
          <select 
            id="parentCaseId"
            value={state.parentCaseId}
            onChange={ e => actions.setParentCaseId(e.target.value)}
            className="border-gray-300 focus:border-blue-500 focus:ring-blue-500 h-[35px] w-[250px] mt-2"
          >
            <option value="">Select Case ID...</option>
            {state.existingCases.map(id => (
              <option key={id} value={id}>{id}</option>
            ))}
          </select>
          {state.existingCases.length === 0 && (
            <p className="text-xs text-gray-500 mt-1">No staged cases found.</p>
          )}
        </div>
      )}
    </div>
  );
};
